require('./easyLoanRequestUpload.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
// @constants
const {
    uploadFile,
    MAX_LENGTH_TITLE_UPLOAD_COMPONENT,
    FILE_TYPES,
    easyLoanTypeUpload: {
        IRPF_FILE,
        IRPF130_FILE,
        IRPF100_CLI_FILE,
        IRPF100_CLI_FILE_2,
        IRPF100_FILE,
        IRPF100_CLI_FILE_3,
        IRPF100_CLI_FILE_4,
        EASY_LOAN_CERTIFICATE
    }
} = require('../../../../loansConstants/index');

// @ commons
const { OKFileUpload } = require('commonsComponents/OKFileUpload');

// @ helpers
const { hasTranslation, formatText, FormattedText } = require('core/i18n').i18n;

//@utilities
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { recordEasyLoanCUploadFile } = require('../analytics/contractEasyLoanTypeC.tracking');

const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @ constants
const { ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEX } = require('constants/index');

class EasyLoanRequestUpload extends React.Component {
    getInvalidMessage() {
        return formatText('easyLoanTypeCDocumentsUpload-errorInUploadedDocument');
    }

    validateFileObject(immRequest) {
        let response;
        if (!!immRequest.get('file') && (immRequest.getIn(['file', 'name']) || immRequest.get('file').name)) {
            response = immRequest.get('file')
        }
        return response;
    }

    onChange({typeFile, fileState, idx, fileLabel}) {
        const { loadFileInUpload } = this.props;
        loadFileInUpload(typeFile, get(fileState, 'file'), idx, fileLabel)
    }

    buildDragNDropComponent(immFile, typeFile, props) {
        const { clearErrorsFile, removeUploadedFile } = this.props;
        const idx = immFile.get('idx');
        const documentId = immFile.get('documentId');
        const invalid = immFile.get('notValid');
        const error = (immFile.get('error') !== '' && immFile.get('error') !== false) || !!invalid;
        const invalidMessage = this.getInvalidMessage();
        const errorMessageFromImm = hasTranslation(immFile.get('error')) ? formatText(immFile.get('error')) : immFile.get('error');
        const errorMessage = invalid ? invalidMessage : errorMessageFromImm;
        const isCCEnv = __CONTACT_CENTER__ && !isPrintOfficeMode();

        const fileUploadProps = {
            ...props,
            disabled: isCCEnv ? true : immFile.get('isFetching'),
            documentId,
            error,
            errorMessage,
            file: this.validateFileObject(immFile),
            idx,
            invalid,
            invalidCloseButton: true,
            loading: immFile.get('isFetching'),
            newFileName: immFile.get('newName'),
            valid: !invalid,
            texts: {
                editFileName: formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_editFileName'),
                editReturn: <FormattedText value="payrollLoanRequestStepThree-payrollLoanRequestStepThree_pressEnterToSave" />,
                errorSize: formatText('payrollLoanRequestStepThree-uploadSizeError', [uploadFile.MAX_SIZE_FILE]),
                errorType: formatText('payrollLoanRequestStepThree-uploadTypeError', [FILE_TYPES.join(', ')]),
                errorTypeSize: formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadTypeAndSizeError'),
                supportedFormats: formatText('dragNDropUpload-supportedFormats', [FILE_TYPES.join(', ').toUpperCase()]),
                uploadSuccess: formatText('payrollLoanRequestStepThree-payrollLoanRequestStepThree_uploadFileSuccess'),
                uploadText: formatText('dragNDropUpload-defaultDescription'),
                uploadLink: formatText('dragNDropUpload-defaultDescriptionSelectFile')
            },
            handlers: {
                ...get(props, 'handlers'),
                change: fileState => this.onChange({fileState, typeFile, idx, fileLabel: props.fileDescription}),
                removeFile: () => removeUploadedFile(typeFile, idx, documentId),
                clearErrors: () => clearErrorsFile(typeFile, idx, documentId),
                uploadPicture: () => {
                    recordEasyLoanCUploadFile(props.fileDescription)
                }
            }
        };

        return (
            <OKFileUpload
                {...fileUploadProps}
                allowFileNameRegexp={ONLY_LETTERS_ACCENTS_NUMBERS_SPACES_GUIDES_REGEX}
                titleLength={uploadFile.NAME_LENGTH}
                maxSize={uploadFile.MAX_SIZE_FILE}
                hideFormats
                hideSizeLimit
                maxLengthTitleUpload={MAX_LENGTH_TITLE_UPLOAD_COMPONENT}
                validTypesFile={FILE_TYPES}
            />
        );
    }

    buildUploadFileEasyLoanCertificate() {
        const {
            immContractEasyLoan
        } = this.props;
        const immUpload = immContractEasyLoan.get('upload');
        const immFile = immUpload.get(EASY_LOAN_CERTIFICATE);
        const fileDescription = formatText('easyLoanTypeCDocumentsUpload-easyLoanFileDescription');
        const dragNDrop = this.buildDragNDropComponent(immFile, EASY_LOAN_CERTIFICATE, {
            fileDescription,
            idName: 'certificadoFile',
        });
        const contactCenterContent = __CONTACT_CENTER__ || isPrintOfficeMode() ? dragNDrop : null;
        return (
            <div className="easy-loan-request-upload__container-drag-n-drop col-md-4">
                <WebappRender>
                    {dragNDrop}
                </WebappRender>
                <ContactCenterRender>
                    {contactCenterContent}
                </ContactCenterRender>
            </div>
        );
    }

    buildUploadFileIrpfComponent(fileType = IRPF_FILE, text = 'easyLoanTypeCDocumentsUpload-irpf100FileDescription') {
        const { immContractEasyLoan } = this.props;
        const immUpload = immContractEasyLoan.get('upload');

        const immFile = immUpload.get(fileType);
        const fileDescription = formatText(text);

        const dragNDrop = this.buildDragNDropComponent(immFile, fileType, {
            fileDescription,
            idName: fileType
        });

        const contactCenterContent = __CONTACT_CENTER__ || isPrintOfficeMode() ? dragNDrop : null;
        return (
            <div className=" easy-loan-request-upload__container-drag-n-drop col-md-4">
                <WebappRender>
                    {dragNDrop}
                </WebappRender>
                <ContactCenterRender>
                    {contactCenterContent}
                </ContactCenterRender>
            </div>
        );
    }

    render() {
        const { immContractEasyLoan } = this.props;
        const easyLoanCertificateComponent = this.buildUploadFileEasyLoanCertificate();
        const requiredDocs = immContractEasyLoan.getIn(["upload", "requiredDocs"]);
        const nomVLRequired = typeof (requiredDocs.get(EASY_LOAN_CERTIFICATE)) === 'object'
        const irpf100Required = typeof (requiredDocs.get(IRPF_FILE)) === 'object'
        const irpf130Required = typeof (requiredDocs.get(IRPF130_FILE)) === 'object'
        const irpf100CLIRequired = typeof (requiredDocs.get(IRPF100_CLI_FILE)) === 'object'
        const irpf100CLIRequired2 = typeof (requiredDocs.get(IRPF100_CLI_FILE_2)) === 'object'
        const irpf100RequiredFile = typeof (requiredDocs.get(IRPF100_FILE)) === 'object'
        const irpf100CLIRequired3 = typeof (requiredDocs.get(IRPF100_CLI_FILE_3)) === 'object'
        const irpf100CLIRequired4 = typeof (requiredDocs.get(IRPF100_CLI_FILE_4)) === 'object'

        return (
            <div>
                <div className="row">
                    {nomVLRequired && easyLoanCertificateComponent}
                    {irpf100Required && this.buildUploadFileIrpfComponent(IRPF_FILE, 'easyLoanTypeCDocumentsUpload-irpf100FileDescription')}
                    {irpf130Required && this.buildUploadFileIrpfComponent(IRPF130_FILE, 'easyLoanTypeCDocumentsUpload-irpf130FileDescription')}
                    {irpf100CLIRequired && this.buildUploadFileIrpfComponent(IRPF100_CLI_FILE, 'easyLoanTypeCDocumentsUpload-irpf100CLIFileDescriptionOne')}
                    {irpf100RequiredFile && this.buildUploadFileIrpfComponent(IRPF100_FILE, 'easyLoanTypeCDocumentsUpload-irpf100CLIFileDescriptionOne')}
                    {irpf100CLIRequired2 && this.buildUploadFileIrpfComponent(IRPF100_CLI_FILE_2, 'easyLoanTypeCDocumentsUpload-irpf100CLIFileDescriptionTwo')}
                    {irpf100CLIRequired3 && this.buildUploadFileIrpfComponent(IRPF100_CLI_FILE_3, 'easyLoanTypeCDocumentsUpload-irpf100CLIFileDescriptionThree')}
                    {irpf100CLIRequired4 && this.buildUploadFileIrpfComponent(IRPF100_CLI_FILE_4, 'easyLoanTypeCDocumentsUpload-irpf100CLIFileDescriptionFour')}
                </div>
            </div>
        );
    }
}

EasyLoanRequestUpload.propTypes = {
    handlerEditFileName: PropTypes.func.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    loadFileInUpload: PropTypes.func.isRequired,
    recordStatus: PropTypes.string.isRequired,
    removeUploadedFile: PropTypes.func.isRequired,
    clearErrorsFile: PropTypes.func.isRequired,
};

module.exports = EasyLoanRequestUpload;
